// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".index-view{margin-top:5%;margin-bottom:5%;width:100%;max-width:100%;height:60vh;min-height:500px}.offline-message-view{margin-top:15%;margin-bottom:15%;width:100%;max-width:100%;height:auto}.cart-view{margin-top:5%;margin-bottom:5%;width:100%;max-width:100%;height:60vh;min-height:500px;text-align:center}", ""]);
// Exports
module.exports = exports;
